import { Link } from "react-router-dom";

const entries = [
  {
    type: "movie",
    title: "电影",
    desc: "院线佳作、经典口碑，一站浏览",
    icon: "ri-film-line",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20image%20of%20a%20grand%20classic%20movie%20theater%20with%20rows%20of%20warm%20amber%20seats%20and%20a%20glowing%20screen%2C%20deep%20navy%20shadows%2C%20atmospheric%20haze%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=900&height=520&seq=category-entry-movie&orientation=landscape",
  },
  {
    type: "tv",
    title: "电视剧",
    desc: "热播剧集、口碑长剧，追剧不停",
    icon: "ri-tv-2-line",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20image%20of%20a%20cozy%20living%20room%20at%20dusk%20with%20a%20large%20glowing%20television%20screen%20and%20warm%20amber%20lamp%20light%2C%20deep%20teal%20shadows%2C%20atmospheric%20haze%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=900&height=520&seq=category-entry-tv&orientation=landscape",
  },
];

export default function CategoryEntry() {
  return (
    <section className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
      {entries.map((entry) => (
        <Link
          key={entry.type}
          to={`/category/${entry.type}`}
          className="group relative h-44 md:h-52 rounded-lg overflow-hidden cursor-pointer"
        >
          <img
            src={entry.image}
            alt={entry.title}
            title={`${entry.title} - 影视资源分类`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/60 to-primary-950/20"></div>
          <div className="absolute inset-0 p-6 flex flex-col justify-center">
            <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-500 text-primary-950 mb-3">
              <i className={`${entry.icon} text-xl`}></i>
            </span>
            <h3 className="text-xl md:text-2xl font-bold text-background-50 font-heading">{entry.title}</h3>
            <p className="mt-1 text-sm text-background-300">{entry.desc}</p>
            <span className="mt-3 text-sm text-accent-400 flex items-center gap-1">
              进入分类
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
            </span>
          </div>
        </Link>
      ))}
    </section>
  );
}